import { Button } from "primereact/button";
import React from "react";
import { T } from "services/lang/LanguageService";
import { downloadStringAsFile } from "utils/file-utils";

interface SimpleJsonExportButtonProps {
  data: any;
  filename?: string;
  tooltip?: string;
  tooltipPosition?: "top" | "bottom" | "left" | "right" | "mouse";
}

const SimpleJsonExportButton = ({
  data,
  filename,
  tooltip,
  tooltipPosition,
}: SimpleJsonExportButtonProps) => {
  const tempData = typeof data === "string" ? data : JSON.stringify(data);
  return (
    <Button
      icon="pi pi-file-export"
      tooltip={tooltip ?? T("action.export-data")}
      className="p-button-success align-self-center"
      onClick={() => downloadStringAsFile(tempData, filename ?? "data.json")}
      tooltipOptions={{ showDelay: 500, hideDelay: 300, position: tooltipPosition ?? "top" }}
    />
  );
};

export default SimpleJsonExportButton;
